import { Select } from 'antd';
import React, { useEffect, useState } from 'react';
import Style from './style';
import Chart from './chart';
import Frame from '../frame';
import { useSdgs } from './hook';
import { periods } from './helper';
import { DashboardService } from '../../../../../../../services';
import { getPopupContainer } from '../../../../../../../helpers/popUp';
import DashboardPopover from '../../../../../../../components/dashboards/components/Popover';

const Contributors = ({
  t = (s) => s,
  language,
  canFetch = false,
  settings,
}) => {
  const [data, setData] = useState(null);
  const [activeFilter, setActiveFilter] = useState(
    settings?.defaultFilters?.sdgs || 'past12Months'
  );

  useEffect(() => {
    if (settings?.defaultFilters?.sdgs) {
      setActiveFilter(settings?.defaultFilters?.sdgs);
    }
  }, [settings]);

  const {
    items,
    _totalEvents,
    setFrameActions,
  } = useSdgs({ data, activeFilter });

  const _fetch = async () => {
    try {
      setData(null);
      const res = await DashboardService.getPmeProject({
        widget: 'sdgs',
        filters: {
          periods: activeFilter,
        }
      })
      if (res.data?.sdgs) {
        setData(res.data?.sdgs);
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (canFetch) {
      _fetch();
    }
  }, [language, canFetch, activeFilter]);

  return (
    <Frame
      onInit={actions => setFrameActions(actions)}
      title={t('SDGs')}
      optionalHeaderContent={(
        <Select
          style={{ width: 100 }}
          {...getPopupContainer()}
          className='custom-select'
          value={activeFilter}
          onChange={(val) => setActiveFilter(val)}
        >
          {periods.map((v, i) => (
            <Select.Option
              value={v.value}
              key={`key-tasks-${i}-${v.value}`}
            >
              {t(v.label)}
            </Select.Option>
          ))}
        </Select>
      )}
      tooltip={(
        <DashboardPopover
          title={t('SDGs')}
          body={t('Project contribution to the Sustainable Development Goals (SDG), based on corrective actions reported by information sources included in the project.')}
        />
      )}
    >
      {!!data && (
        <Style>
          <Chart
            t={t}
            data={items}
            totalEvents={data ? data.totalEvents : 0}
          />
          <div className="overview-footer">
            <p>
              <span className="text-blue">
                {_totalEvents || 0}
              </span>
              {' '}
              {t('Dashboard::interventions')}
              {' '}
              {t('Dashboard::related to')}
              {' '}
              <span className="text-blue">{items.length}</span>
              {' '}
              {t('Dashboard::SDGs')}
            </p>
          </div>
        </Style>
      )}
    </Frame >
  );
};

export default Contributors;
